module.exports = __webpack_public_path__ + "media/images/site-section/real-estate-newsletter-image-9f018de77baffbb9b937beab8773d46b.jpg";